module.exports = {
    // 埋点类型
    PointType: {
        S: 'start', // 开始
        E: 'end' // 结束
    }
};



// WEBPACK FOOTER //
// ./src/assets/plugin/track/pathStat/enum.js